<template>
  <div class="aligning">
    <div class="centering">
      {{ startText }}
      <svg :id="type" :width="svgSize" class="legend">
        <g transform="translate(10,0)">
          <template v-for="(color, index) in colors">
            <rect :x="offset(index)" y="0"
                  :height="size"
                  :width="size"
                  :fill="color"></rect>
          </template>
        </g>
      </svg>
      {{ endText }}
    </div>
  </div>
</template>

<script>
    import debounce from "lodash.debounce";

    export default {
      name: 'legendMap',

      props: {
        colors: Array,
        type: String,
        width: Number
      },

      data() {
        return {
          size: 30
        }
      },

      computed: {
        startText() {
          return /^p/.test(this.type) ? 'Drier' : 'Cooler';
        },

        endText() {
          return /^p/.test(this.type) ? 'Wetter' : 'Warmer';
        },

        svgSize() {
          if (this.size === 30) {
            return 320;
          } else if (this.size === 20) {
            return 215;
          } else {
            return 425;
          }
        }
      },

      methods: {
        offset(current) {
          return current * this.size;
        },

        sizing() {
          if (this.width > 1500) {
            this.size = 40;
          } else if (this.width < 675) {
            this.size = 20;
          } else {
            this.size = 30;
          }
        }
      },

      mounted() {
        this.sizing();
      },

      beforeMount() {
        window.addEventListener('resize', debounce(this.sizing, 250));
      },

      beforeDestroy () {
        window.removeEventListener('resize', this.sizing);
      }
    }
</script>

<style scoped>
  div.aligning {
    text-align: center;
  }

  div.centering {
    display: inline-flex;
    margin: auto;
  }

  .legend {
    height: 75px;
  }

  @media (max-width: 675px) {
    div.centering {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/legendMap.vue